// src/envRuntime.js
/* Prioridade: window.__ENV (runtime) > process.env (build) > fallback */
export function env(key, fallback = undefined) {
  const w = typeof window !== "undefined" ? window : undefined;
  if (w && w.__ENV && Object.prototype.hasOwnProperty.call(w.__ENV, key)) {
    return w.__ENV[key];
  }
  if (typeof process !== "undefined" && process.env) {
    const fromBuild = process.env[key] || process.env[`VUE_APP_${key}`];
    if (fromBuild !== undefined) return fromBuild;
  }
  return fallback;
}

// Versão padronizada + sincronismo com localStorage
export function getAppVersion() {
  const desired = env("VUE_APP_VERSION", "dev");
  try {
    const key = "app_version";
    const cur = localStorage.getItem(key);
    if (cur !== desired) {
      localStorage.removeItem("FLEX_venda");
      localStorage.removeItem("flexcard");
      localStorage.setItem(key, desired);
    }
    return desired;
  } catch (e) {
    // Sem localStorage (modo privado / sandbox) → segue com desired
    return desired;
  }
}
